import React from 'react';
import { useTranslation } from 'react-i18next';
import ThunderboltFilled from '@ant-design/icons/ThunderboltFilled';
import { Wrapper, RibbonWrapper, Title } from './InstantBookingRibbon.style';
import RibbonBg from 'assets/images/instant-booking-ribbon.svg';

const InstantBookingRibbon = () => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      <RibbonWrapper bgSrc={RibbonBg}>
        <ThunderboltFilled />
        <Title>{t('INSTANT_BOOKING_BANNER')}</Title>
      </RibbonWrapper>
      <p>{t('INSTANT_BOOKING_INFO')}</p>
    </Wrapper>
  );
};

export default InstantBookingRibbon;
